import { FC } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { AvailabilityAndPriceData } from 'src/pages/transport/network-points/details/availability-and-price-data';
import { CapacityManagement } from 'src/pages/transport/network-points/details/availability-and-price-data/overview/capacity-management';
import { CapacityOverview } from 'src/pages/transport/network-points/details/capacity-overview';
import { MyPortfolioOverview } from 'src/pages/transport/network-points/details/my-portfolio-overview';
import { NetworkPointsDetails } from 'src/pages/transport/network-points/details/point-details';
import {
  NetworkPointParams,
  useNetworkPoint,
} from 'src/pages/transport/network-points/details/use-network-point';
import { useMemoOne } from 'use-memo-one';

export const NetworkPoint: FC = () => {
  const { oldNetworkPointId } = useParams<{ oldNetworkPointId: string }>();

  const networkPointParams = useMemoOne<NetworkPointParams>(
    () => ({ 'include-links': true }),
    []
  );
  const networkPoint = useNetworkPoint({
    oldNetworkPointId,
    params: networkPointParams,
  });

  const monolithUser = useOptionalAuthenticatedMonolithUser();

  const routes = (capacityManagementRoot?: CapacityManagementRootRequest) => (
    <Switch>
      {capacityManagementRoot && (
        <Route path="/transport/network-points/:oldNetworkPointId/availability-and-price-data">
          <AvailabilityAndPriceData
            networkPoint={networkPoint}
            capacityManagementRoot={capacityManagementRoot}
          />
        </Route>
      )}

      {capacityManagementRoot && (
        <Route path="/transport/network-points/:oldNetworkPointId/my-portfolio-overview">
          <MyPortfolioOverview
            networkPoint={networkPoint}
            capacityManagementRoot={capacityManagementRoot}
          />
        </Route>
      )}

      {capacityManagementRoot && (
        <Route path="/transport/network-points/:oldNetworkPointId/capacity-overview">
          <CapacityOverview
            networkPoint={networkPoint}
            capacityManagementRoot={capacityManagementRoot}
          />
        </Route>
      )}

      <Route path="/transport/network-points/:oldNetworkPointId" exact>
        {/* we must wait for the response to get proper 404/410 handling :( */}
        {networkPoint.response ? (
          <NetworkPointsDetails networkPoint={networkPoint} />
        ) : (
          <PageSpinner />
        )}
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );

  if (monolithUser) {
    return <CapacityManagement>{routes}</CapacityManagement>;
  } else {
    return routes();
  }
};
